import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Save } from 'lucide-react';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { z } from 'zod';
import { serviceCreateSchema, serviceUpdateSchema, type ServiceUpdate } from '../../../../../packages/contracts/src/index.js';
import { Button } from '../../components/ui/button';
import { ErrorState, LoadingState } from '../../components/ui/state';
import { api } from '../../shared/api';
import { ServiceFields, ServiceFormShell } from './ServiceCreatePage';

type ServiceFormInput = z.input<typeof serviceCreateSchema>;
type ServiceFormOutput = z.output<typeof serviceCreateSchema>;

export function ServiceEditPage() {
  const { serviceId = '' } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const serviceQuery = useQuery({ queryKey: ['service', serviceId], queryFn: () => api.services.get(serviceId), enabled: Boolean(serviceId) });
  const form = useForm<ServiceFormInput, unknown, ServiceFormOutput>({ resolver: zodResolver(serviceCreateSchema), defaultValues: { name: '', description: '', category: 'boarding', active: true } });
  useEffect(() => { if (serviceQuery.data) form.reset(serviceQuery.data); }, [serviceQuery.data, form]);
  const updateService = useMutation({
    mutationFn: (values: ServiceUpdate) => api.services.update(serviceId, serviceUpdateSchema.parse(values)),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['services'] });
      navigate('/admin/services');
    },
  });
  if (serviceQuery.isLoading) return <LoadingState label="Cargando servicio" />;
  if (serviceQuery.isError) return <ErrorState message={serviceQuery.error.message} />;
  return (
    <ServiceFormShell title="Editar servicio">
      <form className="grid gap-3" onSubmit={form.handleSubmit((values) => updateService.mutate(values))}>
        <ServiceFields form={form} />
        {updateService.isError ? <p className="text-sm text-rose-600">{updateService.error.message}</p> : null}
        <Button type="submit" disabled={updateService.isPending}><Save className="h-4 w-4" aria-hidden="true" />Guardar cambios</Button>
      </form>
    </ServiceFormShell>
  );
}
